import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowIcon } from "../../assets/iconComponents/ArrowIcon";
import { QuestionMark } from "../../assets/iconComponents/QuestionMark";
import { HELP_PAGE_URL } from "../../utils/urlConstants";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  DetailedResultsFAQActionWrapper,
  DetailedResultsFAQArrowWrapper,
  DetailedResultsFAQWrapper,
} from "./DetailedResults.styles";

export const DetailedResultsFAQ = (): React.ReactElement => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <DetailedResultsFAQWrapper>
      <div>
        <QuestionMark />
      </div>
      <div>
        {GetTypographyContent({
          content: t("results.faq.haveQuestion"),
          size: "xlarge",
          textColor: "greyMedium",
          isBold: true,
        })}
      </div>
      <DetailedResultsFAQActionWrapper>
        {GetTypographyContent({
          content: t("results.faq.viewFaqs"),
          size: "medium",
          textColor: "greyMedium",
          link: HELP_PAGE_URL,
        })}
        <DetailedResultsFAQArrowWrapper onClick={() => history.push("./help")}>
          <ArrowIcon />
        </DetailedResultsFAQArrowWrapper>
      </DetailedResultsFAQActionWrapper>
    </DetailedResultsFAQWrapper>
  );
};
